import React from "react";
import { Sparkles } from "lucide-react";

import { data, pct, qtdTotal, qtdVendida, reais } from "../comum/formato";

export default function ResumoFrase({ periodo, r }) {
  if (!r) return null;
  if (!qtdTotal(r)) {
    return <p className="rounded-xl border bg-card p-4 text-sm text-muted-foreground">Nenhuma venda em promoção de {data(periodo.inicio)} a {data(periodo.fim)} com esses filtros.</p>;
  }
  return (
    <div className="rounded-xl border bg-gradient-to-r from-emerald-500/10 to-transparent p-4 flex gap-3" data-e2e="resumo-promocoes">
      <Sparkles className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" />
      <p className="text-sm leading-relaxed">
        De <b>{data(periodo.inicio)}</b> a <b>{data(periodo.fim)}</b> foram <b>{r.kg || r.litros ? qtdVendida(r) : `${qtdVendida(r).replace(/ un$/, "")} unidades`}</b> vendidas em promoção, em <b>{r.pedidos} pedidos</b>,
        faturando <b>{reais(r.faturado)}</b> com <b>{reais(r.desconto)}</b> de desconto{r.retorno ? <> — cada R$ 1 de desconto virou <b>{reais(r.retorno)}</b> em vendas</> : null}.{" "}
        {r.lucro != null ? <>Pela ficha técnica sobrou <b>{reais(r.lucro)}</b> de lucro ({pct(r.margem_pct)} de margem). </> : <>Os produtos em promoção ainda não têm ficha técnica pra calcular o lucro. </>}
        {r.vendas_acompanhantes > 0 ? <>Quem comprou a promoção levou mais <b>{reais(r.vendas_acompanhantes)}</b> em outros produtos (ticket médio de {reais(r.ticket_pedidos)}).</> : null}
      </p>
    </div>
  );
}
